/**
 *
 * chart-utils.services.ts: Totes les utilitats dels gràfics.
 *
 */


import { LinkedDashboardProps } from '@eda/components/eda-panels/eda-blank-panel/link-dashboards/link-dashboard-props';
import { ChartJsConfig } from '../../module/components/eda-panels/eda-blank-panel/panel-charts/chart-configuration-models/chart-js-config';
import { ChartConfig } from '../../module/components/eda-panels/eda-blank-panel/panel-charts/chart-configuration-models/chart-config';
import { Column } from './../../shared/models/dashboard-models/column.model';
import { Injectable } from '@angular/core';
import { EdaChartComponent } from '@eda/components/eda-chart/eda-chart.component';
import * as _ from 'lodash';
import { StyleConfig } from './style-provider.service';
import { KpiConfig } from '@eda/components/eda-panels/eda-blank-panel/panel-charts/chart-configuration-models/kpi-config';
import { DEFAULT_PALETTE_COLOR } from '@eda/configs/index';
import { StyleProviderService } from '@eda/services/service.index';
import { color } from 'd3';

export interface EdaChartType {
    label: string;
    value: string;
    subValue: string;
    icon: string;
    ngIf: boolean;
    tooManyData: boolean;
}

export interface FilterType {
    label: string;
    value: string;
    typeof: string[];
}

export interface OrdenationType {
    display_name: string;
    value: string;
    selected: boolean;
}

export interface FormatDates {
    display_name: string;
    value: string;
    selected: boolean;
}

export interface AssignedColor {
    value: string | number;
    color: string;
}



@Injectable()
export class ChartUtilsService {

    public chartTypes: EdaChartType[] = [
        { label: $localize`:@@chartTypes1:Tabla de Datos`, value: 'table', subValue: 'table', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: true },
        { label: $localize`:@@chartTypes2:Tabla Cruzada`, value: 'crosstable', subValue: 'crosstable', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: true },
        { label: $localize`:@@chartTypesTreeTable:Tabla Árbol`, value: 'treetable', subValue: 'treetable', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: true },
        { label: $localize`:@@chartTypesTableAnalized:Tabla DataQuality`, value: 'table', subValue: 'tableanalized', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: true },
        { label: 'KPI', value: 'kpi', subValue: 'kpi', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: true },
        { label: $localize`:@@chartTypesKPIBAR:KPI + Gráfico de Barras`, value: 'kpibar', subValue: 'kpibar', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: true },
        { label: $localize`:@@chartTypesKPILINE:KPI + Gráfico de Lineas`, value: 'kpiline', subValue: 'kpiline', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: true },
        { label: $localize`:@@chartTypesKPIAREA:KPI + Gráfico de Áreas`, value: 'kpiline', subValue: 'kpiarea', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: true },
        { label: $localize`:@@chartTypesDynamicText:Texto Dinámico`, value: 'dynamicText', subValue: 'dynamicText', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: true },
        { label: $localize`:@@chartTypes15:Velocímetro`, value: 'knob', subValue: 'knob', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: false },
        { label: $localize`:@@chartTypes3:Gráfico de Pastel`, value: 'doughnut', subValue: 'doughnut', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: true },
        { label: $localize`:@@chartTypes4:Gráfico de Área Polar`, value: 'polarArea', subValue: 'polarArea', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: true },
        { label: $localize`:@@chartTypes17:Gráfico Solar`, value: 'sunburst', subValue: 'sunburst', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: true },
        { label: $localize`:@@chartTypes5:Gráfico de Barras`, value: 'bar', subValue: 'bar', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: true },
        { label: $localize`:@@chartTypesHistograma:Histograma`, value: 'bar', subValue: 'histogram', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: true },
        { label: $localize`:@@chartTypes6:Gráfico de Barras Apiladas`, value: 'bar', subValue: 'stackedbar', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: true },
        { label: $localize`:@@chartTypes19:Gráfico de Barras Apiladas al 100%`, value: 'bar', subValue: 'stackedbar100', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: true },
        { label: $localize`:@@chartTypes7:Gráfico de Barras Horizontales`, value: 'bar', subValue: 'horizontalBar', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: true },
        { label: $localize`:@@chartTypesPyramid:Gráfico de Piramide`, value: 'bar', subValue: 'pyramid', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: true },
        { label: $localize`:@@chartTypes8:Gráfico de Lineas`, value: 'line', subValue: 'line', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: true },
        { label: $localize`:@@chartTypes18:Gráfico de Áreas`, value: 'line', subValue: 'area', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: true },
        { label: $localize`:@@chartTypes9:Mixto: Barras y lineas`, value: 'bar', subValue: 'barline', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: true },
        { label: $localize`:@@chartTypes12:ParallelSets`, value: 'parallelSets', subValue: 'parallelSets', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: false },
        { label: $localize`:@@chartTypes13:TreeMap`, value: 'treeMap', subValue: 'treeMap', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: false },
        { label: $localize`:@@chartTypes14:ScatterPlot`, value: 'scatterPlot', subValue: 'scatterPlot', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: false },
        { label: $localize`:@@chartTypes16:Funnel`, value: 'funnel', subValue: 'funnel', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: false },
        { label: $localize`:@@chartTypesBubblechart:Bubblechart`, value: 'bubblechart', subValue: 'bubblechart', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: false },
        { label: $localize`:@@chartTypes10:Mapa de coordenadas`, value: 'coordinatesMap', subValue: 'coordinatesMap', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: false },
        { label: $localize`:@@chartTypes11:Mapa de Capas`, value: 'geoJsonMap', subValue: 'geoJsonMap', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: false },
        { label: $localize`:@@chartTypesRadar:Radar`, value: 'radar', subValue: 'radar', icon: 'pi pi-exclamation-triangle', ngIf: true, tooManyData: false },
    ];

    public filterTypes: FilterType[] = [
        { label: $localize`:@@filters1:IGUAL A (=)`, value: '=', typeof: ['numeric', 'date', 'text'] },
        { label: $localize`:@@filters2:NO IGUAL A (!=)`, value: '!=', typeof: ['numeric', 'date', 'text'] },
        { label: $localize`:@@filters3:MAYOR A (>)`, value: '>', typeof: ['numeric', 'date'] },
        { label: $localize`:@@filters4:MENOR A (<)`, value: '<', typeof: ['numeric', 'date'] },
        { label: $localize`:@@filters5:MAYOR o IGUAL A (>=)`, value: '>=', typeof: ['numeric', 'date'] },
        { label: $localize`:@@filters6:MENOR o IGUAL A (<=)`, value: '<=', typeof: ['numeric', 'date'] },
        { label: $localize`:@@filters7:ENTRE (between)`, value: 'between', typeof: ['numeric', 'date'] },
        { label: $localize`:@@filters8:DENTRO DE (in)`, value: 'in', typeof: ['numeric', 'date', 'text'] },
        { label: $localize`:@@filters9:FUERA DE (not in)`, value: 'not_in', typeof: ['numeric', 'date', 'text'] },
        { label: $localize`:@@filters10:PARECIDO A (like)`, value: 'like', typeof: ['text'] },
        { label: $localize`:@@filters11:NO PARECIDO A (not like)`, value: 'not_like', typeof: ['text'] },
        { label: $localize`:@@filters12:VALORES NO NULOS (not null)`, value: 'not_null', typeof: ['numeric', 'date', 'text'] },
        { label: $localize`:@@filters13:VALORES NO NULOS NI VACÍOS (not null and != '')`, value: 'not_null_nor_empty', typeof:  ['numeric', 'date', 'text']},
        { label: $localize`:@@filters14:VALORES NULOS O VACÍOS (null or = '')`, value: 'null_or_empty', typeof:  ['numeric', 'date', 'text']},
    ];

    public ordenationTypes: OrdenationType[] = [
        { display_name: 'Asc', value: 'Asc', selected: false },
        { display_name: 'Desc', value: 'Desc', selected: false },
        { display_name: 'No', value: 'No', selected: false }
    ];

    public formatDates: FormatDates[] = [
        { display_name: $localize`:@@dates1:AÑO`, value: 'year', selected: false },
        { display_name: $localize`:@@datesQ:TRIMESTRE`, value: 'quarter', selected: false },
        { display_name: $localize`:@@dates2:MES`, value: 'month', selected: false },
        { display_name: $localize`:@@dates5:SEMANA`, value: 'week', selected: false },
        { display_name: $localize`:@@dates3:DIA`, value: 'day', selected: false },
        { display_name: $localize`:@@dates6:DIA DE LA SEMANA`, value: 'week_day', selected: false },
        { display_name: $localize`:@@dates8:DIA HORA`, value: 'day_hour', selected: false },
        { display_name: $localize`:@@dates9:DIA HORA MINUTO`, value: 'day_hour_minute', selected: false },
        { display_name: $localize`:@@dates7:FECHA COMPLETA`, value: 'timestamp', selected: false },
        { display_name: $localize`:@@dates4:NO`, value: 'No', selected: false }
    ];

    public histoGramRangesTxt: string = $localize`:@@histoGramRangesTxt:Rango`;

    public MyPaletteColors: string[] = DEFAULT_PALETTE_COLOR;
    /*
        Funció especifica per transformar les dades per el velocímetre (knob)
    */
    public transformData4Knob(data: any, dataTypes: string[]): any {
        let values = [];
        let res = { labels: [], values: [] };
        const idx = { label: null, serie: null, numeric: [] };
        if (data.values.length > 0) {
            dataTypes.forEach((e: any, i) => {
                e === 'numeric' ? idx.numeric.push(i) : idx.label != null ? idx.serie = i : idx.label = i;
            });

            data.values.forEach((e: any, i) => {
                idx.numeric.forEach((elem, index) => {
                    values.push(e[idx.numeric[index]]);
                })
            });
            res.values[0] = values.slice(0, 2);
            res.labels = data.labels.slice(0, 2);
        }
        return res;
    }


    /*
        Aquesta funció manipula les dades per donar-los la forma que esperen els grafics ng-chart
        numberOfColumns es el numero de columnes que farem servidr en el histograma
    */
    public transformDataQuery(type: string, subType: string,  values: any[], dataTypes: string[], dataDescription: any, isBarline: boolean, numberOfColumns: number) {

        // If there is more than 1 column and all are numeric, convert the first one to text
        const allNumeric = dataTypes.length > 1 && !dataTypes.find(t => t !== 'numeric');
        if (allNumeric) {
            dataTypes[0] = "text";
            const columnaNumerica = dataDescription.numericColumns.shift();
            dataDescription.otherColumns.unshift(columnaNumerica);
        }

        dataTypes.forEach( (e,indice)=>{            
            if(e=='text'){
                values.forEach( (v) => {
                    v[indice] = (v[indice] == '' || v[indice] == ' ' || v[indice] === null ) ? '-' :  v[indice] ; //canviem les cadenes buides i els null de text per un '-';                   
                })}
        })
        
        let output = [];
        const idx = { label: null, serie: null, numeric: [] };

        dataTypes.forEach((e: any, i) => {
            e === 'numeric' ? idx.numeric.push(i) : idx.label != null ? idx.serie = i : idx.label = i;
        });
        

        const label_idx = idx.label;
        const serie_idx = idx.serie;
        const number_idx = idx.numeric[0];

        if (type === 'doughnut' || type === 'polarArea') {
            const _labels = values.map(v => v[label_idx]);
            const _values = values.map(v => v[number_idx]).filter(elem => elem != null);

            // Faig push a l'array output, que sera retornat per l'inicialització del PieChart
            const _output = [[], []];
            _output[0] =  _output[0] = values.map(v => v[label_idx]);
            _output[1] = [{ data: values.map(v => v[number_idx]) }];
                 
            if (dataDescription?.otherColumns?.length > 0) {
                _output[1][0].label = dataDescription?.otherColumns[0]?.name
            }

            output =  _output;
        } 
        else if (['bar' ].includes(type)  && ['pyramid' ].includes(subType) ) {
            const l = Array.from(new Set(values.map(v => v[label_idx])));
            const s = serie_idx !== -1 ? Array.from(new Set(values.map(v => v[serie_idx]))) : null;
            const _output = [[], []];
            _output[0] = l;

            //necesitamos dos series de datos y uno numérico para hacer una pirámide
            if (dataDescription.otherColumns.length === 2 && dataDescription.numericColumns.length === 1) {
                let series = [];
                s.forEach((s) => {
                    _output[1].push({ data: [], label: s });
                    let serie = values.filter(v => v[serie_idx] === s);
                    series.push(serie);
                });
                l.forEach((l) => {
                    // let data_point = null;
                    series.forEach((serie, i) => {
                        const t = serie.filter(s => s[label_idx] === l).map(e => e[number_idx])[0];
                        t !== null ? _output[1][i].data.push(t) : _output[1][i].data.push(null);
                    });
                });
                //If >1 numeric series
            }

            //para el gráfico de pirámide, cogemos los valores del primer segmento y los multiplicamos por -1.
            let u = _.cloneDeep(_output[1])
            let inverData = []
            for (let i=0;i<u.length;i++) {
                if (i==0) {
                    u[i].data.filter(a => {
                       inverData.push(a * -1)
                    })
                    u[i].data = inverData;
                }
            }

            _output[1] = u
            output =  _output;

        } else if(['bar'].includes(type) && ['stackedbar100'].includes(subType)) {

            const l = serie_idx !== null ? Array.from(new Set(values.map(v => v[label_idx]))) :  Array.from(new Set(dataDescription.numericColumns.map(v => v.name)));
            const s = serie_idx !== null ? Array.from(new Set(values.map(v => v[serie_idx]))) : Array.from(new Set(values.map(v => v[label_idx])));

            const _output = [[], []];
            _output[0] = l;

            let total = 0;
            values.forEach((i,j) => {
                total = total + i[number_idx];
            });

            //If are two text series and one number category
            if (dataDescription.otherColumns.length === 2 && dataDescription.numericColumns.length === 1) {
                let series = [];

                s.forEach((s) => {
                    _output[1].push({ data: [], label: s, value: [], mode: 'textTwoNumericOne' });
                    let serie = values.filter(v => v[serie_idx] === s);
                    series.push(serie);
                });

                l.forEach((l) => {
                    // let data_point = null;
                    series.forEach((serie, i) => {
                        const t = serie.filter(s => s[label_idx] === l).map(e => e[number_idx])[0];
                        t !== undefined ? _output[1][i].data.push(t) : _output[1][i].data.push(0);
                    });
                });

                // calibrar los valores al 100%
                let totales = [];
                for (var k = 0; k < l.length; k++) totales[k] = 0; // inicializando totales
                
                // recolectando todas las sumas
                _output[1].forEach((e:any) => {
                    e.data.forEach((v:any,j:number) => {
                        totales[j]=totales[j]+v;
                    })
                })

                // Agregando los valores de porcentaje
                const _outputTemporal = _output[1];

                _outputTemporal.forEach((e:any, k:number) => {
                    e.data.forEach((v:any, j:number) => {
                        if(totales[j]===0) {

                            _output[1][k].value[j]=0;
                            _output[1][k].data[j]=0;
                        }
                        else {
                            _output[1][k].value[j] = v;
                            _output[1][k].data[j] = v*100/totales[j];
                        }
                    })
                })
            }

            //If is one text series and more than two number categories
            else if (dataDescription.otherColumns.length === 1 && dataDescription.numericColumns.length >= 1) {
                let series = [];
                let totalGenerico = [];

                for (var i = 0; i < l.length; i++) {
                    totalGenerico[i] = 0;
                }

                let label_idx = idx.label;
                let serie_idx = idx.label; // El unico valor de texto

                s.forEach((s) => {
                    _output[1].push({ data: [], label: s , value: [],  mode: 'textOneNumericN' });
                    let serie = values.filter(v => v[serie_idx] === s);
                    series.push(serie);
                });

                series.forEach(v => {
                    _output[1].forEach(p => {

                        if(v[0][label_idx] === p.label){
                            p.data = v[0].filter(i => i!==p.label);
                            p.data.forEach((c, j) => {
                                if(typeof c !== 'number') {
                                    p.data[j] = 0
                                }
                            })
                        }
                    })
                })

                // calibrar los valores al 100%
                // Calculando las sumas de cada campo
                _output[1].forEach((e) => {
                    e.data.forEach((v,j) => {
                        totalGenerico[j] = totalGenerico[j] + v
                    })
                })
                
                // ejecutando el porcentaje 100%
                _output[1].forEach((e) => {
                    for (var i = 0; i < l.length; i++) {
                        e.value[i] = (e.data[i]); // Valor numérico
                        e.data[i] = ((e.data[i] * 100)/totalGenerico[i]); // Valor numérico en porcetaje
                    }
                })
            }

            output =  _output;

        } else if (['bar', 'kpibar', 'line', 'kpiline', 'area', 'kpiarea', 'horizontalBar', 'barline', 'histogram' ,'radar' ].includes(type)  &&  dataTypes.length >  1 ) {

            const l = Array.from(new Set(values.map(v => v[label_idx])));
            const s = serie_idx !== -1 ? Array.from(new Set(values.map(v => v[serie_idx]))) : null;
            const _output = [[], []];
            _output[0] = l;

            //If one serie
            if (dataDescription.otherColumns.length === 1 && dataDescription.numericColumns.length === 1) {
                _output[0] = values.map(v => v[label_idx]);
                _output[1] = [{
                    data: values.map(v => v[number_idx]),
                    label: dataDescription.otherColumns[0].name
                }];
                //if two series
            } 
            else if (dataDescription.numericColumns.length === 1) {
                let series = [];
                s.forEach((s) => {
                    _output[1].push({ data: [], label: s });
                    let serie = values.filter(v => v[serie_idx] === s);
                    series.push(serie);
                });
                l.forEach((l) => {
                    // let data_point = null;
                    series.forEach((serie, i) => {
                        const t = serie.filter(s => s[label_idx] === l).map(e => e[number_idx])[0];
                        t !== null ? _output[1][i].data.push(t) : _output[1][i].data.push(null);
                    });
                });
                //If >1 numeric series
            } 
            else if (!isBarline) {
                dataDescription.numericColumns.forEach((col, i) => {
                    _output[1].push(
                        {
                            data: values.map(v => v[col.index]),
                            label: col.name
                        });
                });
                // >1 numeric series and is mixed bar-line
            } 
            else {
                dataDescription.numericColumns.forEach((col, i) => {
                    let isLine = i === dataDescription.numericColumns.length - 1;
                    _output[1].push(
                        {
                            data: values.map(v => v[col.index]),
                            label: col.name,
                            type: isLine ? 'line' : 'bar',
                            borderWidth: 1,
                            fill: false,
                            order: isLine ? 0 : i + 1,
                            pointRadius: 2,
                            pointHitRadius: 4,
                            pointHoverRadius: 3,
                            pointHoverBorderWidth: 2
                        });
                });
            }
            output =  _output;

            /* Histograma  */
        } else if (  ['bar'].includes(type) &&  dataTypes.length ==  1 && dataTypes[0]== 'numeric'   ) {
            let distinctNumbers  = Array.from(new Set(values.map(v => v[number_idx]))).filter(element => {
                return element !== null;
            });;
            let allNumbers = values.map(v => v[number_idx]).filter(element => {
                return element !== null;
            });;
            const _output = [[], []];

            let grupos = [];
            let new_data=[];
            let num_cols=0;
            let salto=0;
            //Si hay nulos van a parte
            const grupo_null =  values.map(v => v[number_idx]).filter(element => {
                return element === null;
            });;
            distinctNumbers = distinctNumbers.sort(function(a,b){
                return a-b
            });
            allNumbers = allNumbers.sort(function(a,b){
                return a-b
            });
            const min = Math.min(...distinctNumbers);
            const max= Math.max(...distinctNumbers);
            let range = (max-min) +1;
            if( grupo_null.length > 0 ){
                range = range+1;
            }
            if(range<30){
                num_cols=range;
            }else if(range>=30 && range<=100){
                num_cols=30
            }else {
                num_cols=50;
            }

            //No me llega el numero de columnas fijo el numero de columnas
            if(!isNaN(numberOfColumns) &&  numberOfColumns !== null ){
                num_cols=numberOfColumns;
            }

           if( this.esEntero(distinctNumbers)){
                salto =  Math.ceil( max/num_cols )  ;
            }else{
                num_cols<5?num_cols=5:num_cols=num_cols;
                salto =   Math.ceil( max/num_cols * 10) / 10 ;
            }
            if(salto == 1 ){
                new_data = this.generateNewDataOneForHistogram(allNumbers,num_cols,min,max , salto);
                grupos =   this.generateGruposOneForHistogram( num_cols,min );
            }
            else{
                if(!isNaN(numberOfColumns) &&  numberOfColumns !== null ){
                    num_cols=numberOfColumns;
                }
                new_data = this.generateNewDataRangeForHistogram(allNumbers,distinctNumbers,num_cols,min,max , salto);
                /** array de un único elemento. Cuando tenga mas ya veré lo que hago */
                grupos =   this.generateGruposRangeForHistogram( num_cols,min,max , salto, this.esEntero(distinctNumbers) , dataDescription.query[0].minimumFractionDigits);
            }
            if(grupo_null.length > 0 ){
                new_data.push(grupo_null.length  );
                grupos.push('null');
            }
            _output[0]=grupos;
            _output[1] = [{
                data: new_data,
                label:  this.histoGramRangesTxt + ' - '  + dataDescription.numericColumns[0].name
            }];

            output =  _output;
        } 

        return output;
    }


    /**
     *
     * @param allNumbers
     * @param num_cols
     * @param min
     * @param max
     * @param salto
     * @returns grupos
     */
    private generateGruposRangeForHistogram( num_cols,min,max, salto , esEntero , minimumFractionDigits ):any[] {
        let mi_salto =  0;
        let mi_min = min;
        let grupos = [];
        for(let i=0; i<num_cols; i++){
            mi_salto =  min+((salto*i)+salto)  ;
            if( mi_salto < max){
                if(esEntero){
                    grupos.push(mi_min+" - "+( mi_salto -1));
                }else{
                    grupos.push(mi_min.toFixed( minimumFractionDigits ) +" - "+ (mi_salto-0.1).toFixed( minimumFractionDigits ));
                }
            }else{
                if(Number.isInteger(mi_min)){
                    grupos.push(mi_min+" - "+max);
                }else{
                    grupos.push( mi_min.toFixed(minimumFractionDigits)+" - "+max.toFixed( minimumFractionDigits ));
                }
                // Salgo del bucle
                i = i+num_cols;
            }



           mi_min = mi_salto;

        }

        return grupos;
    }





    private   generateNewDataRangeForHistogram(allNumbers,distinctNumbers, num_cols,min,max, salto ):any[] {
        let mi_salto =  0;
        let mi_min = min;
        let new_data = [];

        for(let i=0; i<num_cols; i++){
            mi_salto =   min+((salto*i)+salto)   ;
            let grupo = [];

            for( let j=0; j < allNumbers.length; j++){
               if(  ( allNumbers[j] >= mi_min && allNumbers[j] < mi_salto)   &&
               ( mi_salto <  max )
               ){
                    grupo.push(allNumbers[j]);
               }else  if(
                        ( allNumbers[j] >= mi_min && allNumbers[j] <= mi_salto)   &&
                        ( mi_salto >=  max )
               ){
                    grupo.push(allNumbers[j]);
               }
            }


           new_data.push( grupo.length);
           mi_min = mi_salto;
           if( mi_min >= max){
            // Salgo
            i = num_cols;
           }

        }

        return new_data;
    }


    private  generateNewDataOneForHistogram(allNumbers,num_cols,min,max, salto ):any[] {
        let mi_salto =  0;
        let new_data = [];
        for(let i=0; i<num_cols; i++){
            mi_salto =    min+(salto*i);
            let grupo = [];
            for( let j=0; j < allNumbers.length; j++){
               if( allNumbers[j]== mi_salto)  {
                    grupo.push(allNumbers[j]);
               }
            }
           new_data.push( grupo.length);
        }
        return new_data;
    }



    private  generateGruposOneForHistogram(num_cols,min ):any[] {
        let grupos = [];
        for(let i=min; i<=num_cols; i++){
            grupos.push(i);
        }

        return grupos;
    }


/** Ajuda per saber si un númeor es enter o no.  */
    private esEntero(numeros:number[]):boolean{
        let res = true;
        numeros.forEach(
            (numero)=> {
            if ( isNaN(numero)){
                res = false;
            }
            if(numero%1!=0){
                res = false;
            }
        });
        return res;
    }



    public uniqueLabels(labels: Array<string>) {
        const uniqueLabels = [];
        for (let i = 0; i < labels.length; i++) {
            if (uniqueLabels.includes(labels[i])) {
                uniqueLabels.push(`${labels[i]}_${i}`);
            } else {
                uniqueLabels.push(labels[i])
            }
        }
        return uniqueLabels;
    }

    public transformDataQueryForTable(labels: any[], values: any[]) {
            const output = [];
            values = values.filter(row => !row.every(element => element === null));
            // Load the Table for a preview
            for (let i = 0; i < values.length; i += 1) {
                const obj = {};
                for (let e = 0; e < values[i].length; e += 1) { 
                    obj[labels[e]] = values[i][e];
                }
                output.push(obj);
            }
            return output;
    }

    /**
     * Takes current query and returs not allowedCharts
     * @param currentQuery
     * @return [] notAllowed chart types
     */
    public getNotAllowedCharts(dataDescription: any, query: any): any[] {

        let notAllowed =
            [
                'table', 'crosstable', 'kpi','dynamicText', 'geoJsonMap', 'coordinatesMap',
                'doughnut', 'polarArea', 'line', 'kpiline', 'area', 'kpiarea', 'bar', 'kpibar', 'histogram',  'funnel', 'bubblechart',
                'horizontalBar', 'barline', 'stackedbar', 'parallelSets', 'treeMap', 'scatterPlot', 'knob' ,
                'pyramid', 'radar', 'stackedbar100', 'treetable', 'sunburst'
            ];

        //table (at least one column)
        if (dataDescription.totalColumns > 0) notAllowed.splice(notAllowed.indexOf('table'), 1);

        // KPI (only one numeric column)
        if (dataDescription.totalColumns === 1 && dataDescription.numericColumns.length === 1) {
            notAllowed.splice(notAllowed.indexOf('kpi'), 1);
        }

        // DynamicText (only one numeric column)
        if (dataDescription.totalColumns === 1  && dataDescription.otherColumns.length === 1 ) {
            notAllowed.splice(notAllowed.indexOf('dynamicText'), 1);
        }
        // Pie && Polar (Only one numeric column and one char/date column)
        if (dataDescription.totalColumns === 2 && dataDescription.numericColumns.length === 1 || 
            (dataDescription.totalColumns === 2 && dataDescription.numericColumns.length === 2))  {         
            notAllowed.splice(notAllowed.indexOf('doughnut'), 1);
            notAllowed.splice(notAllowed.indexOf('polarArea'), 1);
            notAllowed.splice(notAllowed.indexOf('kpibar'), 1);
            notAllowed.splice(notAllowed.indexOf('kpiline'), 1);
            notAllowed.splice(notAllowed.indexOf('kpiarea',), 1);
        }
        // barchart i horizontalbar  poden ser grafics normals o poden ser histograms....
        if (dataDescription.numericColumns.length >= 1 && dataDescription.totalColumns > 1 && dataDescription.otherColumns.length < 2
            || dataDescription.numericColumns.length === 1 && dataDescription.totalColumns > 1 && dataDescription.totalColumns < 4  /* && aggregation */) {
                notAllowed.splice(notAllowed.indexOf('bar'), 1);
                notAllowed.splice(notAllowed.indexOf('horizontalBar'), 1);
                notAllowed.splice(notAllowed.indexOf('line'), 1);
                notAllowed.splice(notAllowed.indexOf('area'), 1);
                notAllowed.splice(notAllowed.indexOf('stackedbar'), 1);
                notAllowed.splice(notAllowed.indexOf('stackedbar100'), 1);
            }
        if(dataDescription.otherColumns.length===1 && dataDescription.numericColumns.length>=1 && dataDescription.totalColumns>=2 ){
            notAllowed.splice(notAllowed.indexOf('radar'), 1);
        }
        // això es per els histogrames.....
        if (dataDescription.numericColumns.length == 1 && dataDescription.totalColumns == 1 ) {
            notAllowed.splice(notAllowed.indexOf('histogram'), 1);
        }


        if (dataDescription.numericColumns.length > 1 && dataDescription.otherColumns.length < 2) {
            notAllowed.splice(notAllowed.indexOf('barline'), 1);
            const idx = notAllowed.indexOf('stackedbar');
            const idx100 = notAllowed.indexOf('stackedbar100');
            if (idx >= 0 || idx100 >= 0) {
                notAllowed.splice(notAllowed.indexOf('stackedbar'), 1);
                notAllowed.splice(notAllowed.indexOf('stackedbar100'), 1);
            }

        }
        // Crosstable (At least three columns, one numeric)
        if (dataDescription.totalColumns > 2 && dataDescription.numericColumns.length > 0) {
            notAllowed.splice(notAllowed.indexOf('crosstable'), 1);
        }

        //Coordinates map Map (two coordinates and two aditional fields at max)
        if (dataDescription.coordinateColumns === 2) {
            notAllowed.splice(notAllowed.indexOf('coordinatesMap'), 1);
        }

        //GeoJson Map
        if (dataDescription.numericColumns.length === 1
            && dataDescription.query.filter(elem => elem.linkedMap).length > 0
            && dataDescription.totalColumns === 2) {
            notAllowed.splice(notAllowed.indexOf('geoJsonMap'), 1);
        }

        //parallelSets
        if (dataDescription.numericColumns.length === 1 && dataDescription.otherColumns.length > 1) {
            notAllowed.splice(notAllowed.indexOf('parallelSets'), 1);
        }

        //funnel
        if (dataDescription.numericColumns.length === 1 && dataDescription.otherColumns.length == 1) {
            notAllowed.splice(notAllowed.indexOf('funnel'), 1);
        }

        //treeMap
        if (dataDescription.numericColumns.length === 1 && dataDescription.otherColumns.length > 0) {
            notAllowed.splice(notAllowed.indexOf('treeMap'), 1);
        }

        //BubbleChart
        if (dataDescription.numericColumns.length === 1 && dataDescription.otherColumns.length == 1) {
            notAllowed.splice(notAllowed.indexOf('bubblechart'), 1);
        }

        //scatterPlot
        if (dataDescription.numericColumns.length >= 2 && dataDescription.numericColumns.length <= 3
            && dataDescription.otherColumns.length < 3 && dataDescription.otherColumns.length > 0) {
            notAllowed.splice(notAllowed.indexOf('scatterPlot'), 1);
        }

        //knob
        if ((dataDescription.numericColumns.length <= 2 && dataDescription.numericColumns.length > 0
            && dataDescription.otherColumns.length === 0)
            ||
            // si sento un dataset cojo los dos primeros
            // del estilo:
            //  var1 - 10
            //  var 2 - 100
            (dataDescription.numericColumns.length === 1 && dataDescription.otherColumns.length === 1)
        ) {
            notAllowed.splice(notAllowed.indexOf('knob'), 1);
        }

        //pyramid
        if (dataDescription.totalColumns === 3 && dataDescription.numericColumns.length === 1
            ) {
            notAllowed.splice(notAllowed.indexOf('pyramid'), 1);
        }


        // sunbrust two or more value columns and one numeric
        if(  dataDescription.totalColumns > 2 && dataDescription.otherColumns.length >= 1 && dataDescription.numericColumns.length === 1  ) {
            notAllowed.splice(notAllowed.indexOf('sunburst'), 1);
        }

        // Pruebas con hacer dinámico el treeTable
        if(dataDescription.totalColumns > 2) {
            notAllowed.splice(notAllowed.indexOf('treetable'), 1);
        }

        return notAllowed;

    }


    /**
     * Check the resultset size for every chart and return the ones you can not have because you have too many data
     * @param dataSize
     * @return [] notAllowed chart types
     */
    public getTooManyDataForCharts(dataSize: number): any[] {
        let notAllowed =
            ['table', 'crosstable', 'kpi', 'dynamicText', 'knob', 'doughnut', 'polarArea', 'line', 'kpiline', 'bar', 'kpibar','histogram',
                'horizontalBar', 'barline', 'area', 'kpiarea', 'geoJsonMap', 'coordinateMap', 'radar'];

        //table (at least one column)
        notAllowed.splice(notAllowed.indexOf('table'), 1);
        // Crosstable (At least three columns, one numeric)
        notAllowed.splice(notAllowed.indexOf('crosstable'), 1);

        notAllowed.splice(notAllowed.indexOf('geoJsonMap'), 1);
        // Crosstable (At least three columns, one numeric)
        notAllowed.splice(notAllowed.indexOf('coordinateMap'), 1);

        // KPI (only one numeric column)

        if (dataSize === 1) {
            notAllowed.splice(notAllowed.indexOf('kpi'), 1);
            notAllowed.splice(notAllowed.indexOf('dynamicText'), 1);
        }
        // Knomb (only one or two  numeric column)
        // only 2 values
        if (dataSize <= 2) {
            notAllowed.splice(notAllowed.indexOf('knob'), 1);
        }
        // Pie && Polar (Only one numeric column and one char/date column)
        if (dataSize < 100) {
            notAllowed.splice(notAllowed.indexOf('doughnut'), 1);
            notAllowed.splice(notAllowed.indexOf('polarArea'), 1);
        }
        // Bar && Line (case 1: multiple numeric series in one text column, case 2: multiple series in one numeric column)
        if (dataSize < 2500) {
            notAllowed.splice(notAllowed.indexOf('bar'), 1);
            notAllowed.splice(notAllowed.indexOf('kpibar'), 1);
            notAllowed.splice(notAllowed.indexOf('radar'), 1);
            notAllowed.splice(notAllowed.indexOf('horizontalBar'), 1);
        }
        // Bar && Line (case 1: multiple numeric series in one text column, case 2: multiple series in one numeric column)
        if (dataSize < 150000) {
            notAllowed.splice(notAllowed.indexOf('line'), 1);
            notAllowed.splice(notAllowed.indexOf('kpiline'), 1);
            notAllowed.splice(notAllowed.indexOf('area'), 1);
            notAllowed.splice(notAllowed.indexOf('kpiarea',), 1);
            notAllowed.splice(notAllowed.indexOf('barline'), 1);
        }
        //Histogram as many as you want.
        notAllowed.splice(notAllowed.indexOf('histogram'), 1);

        return notAllowed;
    }






/**
 * Genera chartColors en formato Chart.js desde assignedColors
 * @param assignedColors - Array de {value, color}
 * @param chartType - Tipo de chart
 * @returns chartColors en formato esperado por Chart.js
 */
    public generateChartColorsFromAssignedColors(assignedColors: AssignedColor[], chartType: string): any[] {
        
        if (!assignedColors || assignedColors.length === 0) {
            console.warn('generateChartColorsFromAssignedColors: No hay assignedColors');
            return [];
        }
        
        const type = chartType.replace('kpi', '');
        
        switch (type) {
            case 'doughnut':
            case 'polarArea':
                // Formato: [{backgroundColor: [...], borderColor: [...]}]
                return [{
                    backgroundColor: assignedColors.map(c => c.color),
                    borderColor: assignedColors.map(c => c.color)
                }];
                
            case 'histogram':
                // Histogram usa solo el primer color
                return [{
                    backgroundColor: assignedColors[0].color,
                    borderColor: assignedColors[0].color
                }];
                
            default:
                // Bar, Line, Radar, Stacked, etc.
                return assignedColors.map(c => ({
                    backgroundColor: c.color,
                    borderColor: c.color,
                    pointBackgroundColor: c.color,
                    pointBorderColor: c.color
                }));
        }
    }   

    // Funciones de transformaciones de codigos de colores
    private toHex(c: number): string {
        const hex = Math.max(0, Math.min(255, Math.round(c))).toString(16);
        return hex.length === 1 ? '0' + hex : hex;
    }

    public hex2rgb(hex: string): [number, number, number] {
        const cleanHex = hex.replace(/^#/, '');
        const fullHex = cleanHex.length === 3 ?
            cleanHex[0] + cleanHex[0] + cleanHex[1] + cleanHex[1] + cleanHex[2] + cleanHex[2] :
            cleanHex;
        if (fullHex.length !== 6) { return [0, 0, 0]; }
        const bigint = parseInt(fullHex, 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;
        return [r, g, b];
    }

    public hexToRgba(hex: string, opacity: number): string {
        const [r, g, b] = this.hex2rgb(hex);
        const a = Math.max(0, Math.min(100, opacity)) / 100;
        return `rgba(${r}, ${g}, ${b}, ${a})`;
    }

    public rgbToHex(r: number, g: number, b: number): string {
        return `#${this.toHex(r)}${this.toHex(g)}${this.toHex(b)}`;
    }

    public describeData(currentQuery: any, labels: any) {
        let names = this.pretifyLabels(currentQuery, labels);
        let out = { numericColumns: [], coordinateColumns: 0, otherColumns: [], totalColumns: 0, query: currentQuery }
        currentQuery.forEach((col, i) => {
            if (col.column_type === 'numeric') {
                out.numericColumns.push({ name: names[i], index: i });
            } else if (col.column_type === 'coordinate' && [0, 1].includes(i)) {
                out.coordinateColumns += 1;
            } else {
                out.otherColumns.push({ name: names[i], index: i });
            }
            out.totalColumns += 1;
        });
        return out;
    }

    public describeData4Knob(currentQuery: any, chartData: any) {
        let out = { numericColumns: [], coordinateColumns: 0, otherColumns: [], totalColumns: 0, query: currentQuery }
        chartData.values.forEach((element: any[]) => {
            element.forEach((el, indx) => {
                if (!isNaN(el)) {
                    out.numericColumns.push({ name: chartData.labels[indx], index: indx });
                }
            });
            out.totalColumns += 1;
        });
        return out;
    }

    public pretifyLabels(columns: Array<Column>, labels: Array<string>) {
        let names = [];
        labels.forEach(label => {
            columns.forEach(column => {
                if (column.column_name === label) {
                    names.push(column.display_name.default);
                }
            });
        });

        return names
    }

    public get10thPower = (num) => {
        let absNum = Math.abs(num)
        let power = 0;
        while (absNum >= 10) {
            absNum = Math.floor(absNum / 10);
            power++;
        }
        return power;
    }

    public format10thPowers = (num) => {

        const _10thPower = this.get10thPower(num);
        let result = '';

        if (_10thPower >= 6) {
            let reducedNum = (num / Math.pow(10, 6)).toLocaleString('de-DE', { style: 'decimal', maximumFractionDigits: 1 , minimumFractionDigits:0});
            result = reducedNum + 'M'
        }

        else if (_10thPower >= 3) {
            let reducedNum = (num / Math.pow(10, 3)).toLocaleString('de-DE', { style: 'decimal', maximumFractionDigits: 1,  minimumFractionDigits:0 });
            result = reducedNum + 'K'
        }

        else {
            result = num.toLocaleString('de-DE', { style: 'decimal', maximumFractionDigits: 2,  minimumFractionDigits:0 });
        }
        return result
    }

    getMinMax(data: any) {

        let min = Infinity;
        let max = -Infinity;

        data[1].forEach(set => {

            set.data.forEach(value => {
                if (value !== null && value !== undefined) {
                    if (parseFloat(value) > max) max = parseFloat(value);
                    if (parseFloat(value) < min) min = parseFloat(value);
                }
            });

        });

        let min_om = Math.pow(10, Math.floor(Math.log10(Math.abs(min))));
        let min_sign = min < 0;
        min = Math.ceil(Math.abs(min) / min_om) * min_om;


        let max_om = Math.pow(10, Math.floor(Math.log10(Math.abs(max))));
        let max_resto = Math.pow(10, Math.floor(Math.log10(Math.abs(max % max_om))));
        max_resto==0?max_resto=1:max_resto=max_resto;



        // Metode original del pau que arodonia al seguent ordre de magnitud.
        // Pero si el maxim es 10.000  estableix 20.000
        // Ho intento ajustar una mica.
        //max = Math.ceil(max / max_om) * max_om;

        // si estic a valors petit poso el max a 5 o a 10
        if(max_om == 1){
           if(max <1){
                max = 1;
           } else if( max < 3){
               max = 3;
           } else if( max < 5){
                max = 5;
           }else{
               max = 10;
           }
        }else{
            // Ara ho arrodoneix a un mumero mes proper al maxim.al centenar per sobre de  la resta
            if(  ( (max % max_om) /max_om) < 0.5 ){

                // Si tinc motl marge fins a la seguent unitat de magnitut ho arrodoneixo mes paropor
                max = max - ( max % max_om) +
            ( 2* (  Math.ceil(  ( max % max_om) / max_resto )  *  max_resto) );
            }else{
                // Si no ho arodoneixo a la propera unitat de magnitu
                max = Math.ceil(max / max_om) * max_om;
            }
        }
/*
        if (min < max) {
            if (min < max * 0.25) min = max * 0.25;
        } else {
            if (max < min * 0.25) max = min * 0.25;

        }
*/
        if (min_sign) min = -min;
        min = min > 0 && max > 0 ? 0 : min;
        
        return { min: min ? min : 0, max: max ? max : 0 }

    }

    public comparePeriods = (data, query) => {


        let types = query.map(field => field.column_type);
        let dateIndex = types.indexOf('date');
        let newRows = [];

        const format = query.filter((_, i) => i === dateIndex)[0].format;

        data.values.forEach(row => {

            let currentDate = row[dateIndex].slice(-2); /**01, 02, 03 ...etc. */
            let currentHead = row[dateIndex].slice(0, -3); /** 2020-01, 2020-02 ...etc. */

            let newRow = [];

            row.forEach((field, i) => {

                if (i === dateIndex) {
                    newRow.push(currentDate);
                    newRow.push(currentHead);
                } else {
                    newRow.push(field);
                }
            });
            newRows.push(newRow);

        });
        return newRows.sort(function (a, b) {
            if (a[dateIndex] > b[dateIndex]) {
                return 1;
            }
            if (a[dateIndex] < b[dateIndex]) {
                return -1;
            }
            // a must be equal to b
            return 0;
        });

    }

    public getTrend = (values: any) => {
        let x_values = values.data.map((v, y) => y);
        let y_values = this.findLineByLeastSquares(x_values, values.data)[1];

        let trend = _.cloneDeep(values);
        let label = $localize`:@@addtrend:Tendencia`;
        trend.label = `${label} ${trend.label}`;
        trend.data = y_values;

        return trend;
    }

    public findLineByLeastSquares = (values_x, values_y) => {
        let sum_x = 0;
        let sum_y = 0;
        let sum_xy = 0;
        let sum_xx = 0;
        let count = 0;

        /*
         * We'll use those variables for faster read/write access.
         */
        let x = 0;
        let y = 0;
        let values_length = values_x.length;

        if (values_length != values_y.length) {
            throw new Error('The parameters values_x and values_y need to have same size!');
        }

        /*
         * Nothing to do.
         */
        if (values_length === 0) {
            return [[], []];
        }

        /*
         * Calculate the sum for each of the parts necessary.
         */
        for (let v = 0; v < values_length; v++) {
            x = values_x[v];
            y = values_y[v];
            sum_x += x;
            sum_y += y;
            sum_xx += x * x;
            sum_xy += x * y;
            count++;
        }

        /*
         * Calculate m and b for the formular:
         * y = x * m + b
         */
        let m = (count * sum_xy - sum_x * sum_y) / (count * sum_xx - sum_x * sum_x);
        let b = (sum_y / count) - (m * sum_x) / count;

        /*
         * We will make the x and y result line now
         */
        let result_values_x = [];
        let result_values_y = [];

        for (let v = 0; v < values_length; v++) {
            x = values_x[v];
            y = x * m + b;
            result_values_x.push(x);
            result_values_y.push(y);
        }

        return [result_values_x, result_values_y];
    }



    /** inicialitza les opcions dels gràfics. Aqui es on posem tots els detalls del gràfic. */
    public initChartOptions(
        type: string,
        numericColumn: string,
        labelColum: any[],
        manySeries: boolean,
        stacked: boolean,
        size: any,
        linkedDashboard: LinkedDashboardProps,
        minMax: { min: number, max: number },
        styles: StyleConfig,
        showLabels: boolean,
        showLabelsPercent: boolean,
        showPointLines: boolean,
        showPredictionLines: boolean,
        numberOfColumns: number,
        chartSubType: string,
        ticksOptions: any,
        displayLegend: boolean = true,
        showGridLines: boolean = true,
        styleProviderService: StyleProviderService,
    ): { chartOptions: any } {
        let colorStyle : any = styleProviderService.panelFontColor.source['value'];
        let fontStyle : any = styleProviderService.panelFontFamily.source['value'];
        let panelStyle : any = styleProviderService.panelColor.source['value'];
        const t = $localize`:@@linkedTo:Vinculado con`;
        const linked = linkedDashboard ? `${labelColum[0].name} ${t} ${linkedDashboard.dashboardName}` : '';
        let options = { chartOptions: {} };

        // si la pantalla es petita faig la lletra mes petita
        let variador = 0;
        if (window.innerWidth < 1500) {
            variador = -2;
        }
        if (window.innerWidth < 1100) {
            variador = -4;
        }
        const edaFontSize = manySeries ? 10 + variador : 12 + variador + styles.fontSize;

        const edafontStyle = 'normal';
        const edaPieLegend = {
            display: true,
            fontSize: edaFontSize,
            fontStyle: edafontStyle,
            position: 'bottom',
            labels: {
                fontSize: edaFontSize,
                fontFamily: styles.fontFamily,
                fontColor: styles.fontColor,
                boxWidth: manySeries ? 8 + variador : 10 + variador,
                padding: manySeries ? 4 + variador : 8 + variador
            }
        };
        const edaBarLineLegend = {
            display: true,
            fontSize: edaFontSize,
            fontStyle: edafontStyle,
            position: 'bottom',
            labels: {
                fontSize: edaFontSize,
                fontFamily: styles.fontFamily,
                fontColor: styles.fontColor,
                boxWidth: manySeries ? 8 + variador : 10 + variador,
                padding: manySeries ? 4 + variador : 8 + variador,
                filter: function (legendItem, data) {
                    return legendItem.datasetIndex < 20
                },
            }
        };

        const maxTicksLimit = ticksOptions.hasOwnProperty("xTicksLimit") && ticksOptions.xTicksLimit !== null ? ticksOptions.xTicksLimit : (size.width < 200 ? 4 + variador : size.width < 450 ? 10 + variador : size.width < 600 ? 20 + variador : size.width < 800 ? 30 + variador : size.width < 1000 ? 40 + variador : 40 + variador);
        const maxTicksLimitHorizontal = size.height < 200 ? 5 + variador : size.height < 400 ? 12 + variador : size.height < 600 ? 25 + variador : 40 + variador;
        const maxTicksLimitY =  ticksOptions.hasOwnProperty("yTicksLimit") && ticksOptions.yTicksLimit !== null ? ticksOptions.yTicksLimit : (size.height < 100 ? 1  : size.height < 150 ? 2 : size.height < 200 ? 3 :  size.height < 250 ? 4 :  size.height < 300 ? 5 :  size.height < 350 ? 6: 6);

        
        /** Defineixo les propietats en funció del tipus de gràfic. */
        let dataLabelsObjt={}
        switch (type) {
            case 'doughnut':
            case 'polarArea':
                  if(showLabels || showLabelsPercent ){
                            dataLabelsObjt =  {
                                backgroundColor: function(context) {
                                return context.dataset.backgroundColor;
                                },
                                borderColor: 'white',
                                borderRadius: 25,
                                borderWidth: 2,
                                color: 'white',
                                display: function(context) {
                                    const chartWidth = context.chart.width;
                                    const realData = context.dataset.data;
                                    const total = realData.reduce((a, b) => {
                                        return a + b;
                                    }, 0);
                                    const elem = realData[context.dataIndex];
                                    const percentage = elem / total * 100;
                                    if( chartWidth < 200){
                                        return  percentage > 8 ;
                                    }else{
                                        return  percentage > 3; /** Mostro la etiqueta si es mes que el 10 % del total  */
                                    }
                              },
                                font: {
                                    family: fontStyle,
                                weight: 'bold',
                                size:  edaFontSize  ,
                                },
                                padding: 6,
                                formatter: (value,ctx) => {
                                    const datapoints = ctx.dataset.data.map( x => x===''?0:x).map( x => x===undefined?0:x);
                                    const total = datapoints.reduce((total, datapoint) => total + datapoint, 0)
                                    const percentage = value / total * 100
                                    let res = '';
                                    if( showLabels && showLabelsPercent){
                                        res = parseFloat(value).toLocaleString('de-DE', { maximumFractionDigits: 6 })  ;
                                        if(res == 'NaN'){ res = '';}
                                        res = res  + ' - ' + percentage.toLocaleString('de-DE', { maximumFractionDigits: 1 })    + ' %'  ;
                                    }else if(showLabels && !showLabelsPercent){
                                        res = parseFloat(value).toLocaleString('de-DE', { maximumFractionDigits: 6 })  ;
                                    }else if(!showLabels && showLabelsPercent){
                                        res = percentage.toLocaleString('de-DE', { maximumFractionDigits: 1 })    + ' %'   ;
                                    }
                                    return   res;
                                }

                            }
                }else{
                        dataLabelsObjt =   { display: false }
                }
                // Configs reutilizables
                const gridColorConfig = {
                    color: colorStyle
                };

                const tooltipCallbacks = {
                title: (context) => context[0].dataset.label,
                label: (context) => {
                    let label = context.label || '';
                    if (label) label += ': ';
                    label += parseFloat(context.raw).toLocaleString('de-DE', { maximumFractionDigits: 6 });

                    const total = context.dataset.data.reduce((sum, val) => sum + val, 0);
                    const percentage = context.raw / total * 100;
                    label += ' ' + percentage.toLocaleString('de-DE', { maximumFractionDigits: 1 }) + ' %';

                    return label;
                },
                footer: () => linked,
                afterLabel: () => {}
                };

                const legendLabelsFont = {
                family: fontStyle,
                size: 14,
                weight: 'normal'
                };

                // Escalas específicas por polarArea
                let scaleOptions;
                if (type === 'polarArea') {
                    scaleOptions =  {
                        r: {
                            grid: { ...gridColorConfig, display: showGridLines },
                            ticks: {
                                backdropColor: panelStyle,
                                color: colorStyle
                            }
                        }
                    }
                }


                // Configuración final del gráfico
                options.chartOptions = {
                animation: {
                    duration: 2000,
                    animateScale: true,
                    animateRotate: true
                },
                color: colorStyle,
                font: {
                    family: fontStyle
                },
                responsive: true,
                maintainAspectRatio: false,
                devicePixelRatio: 2,
                onHover: (event, chartElement) => {
                    event.native.target.style.cursor = chartElement.length === 1 ? 'pointer' : 'default';
                },
                scales: scaleOptions,
                plugins: {
                    datalabels: dataLabelsObjt,
                    tooltip: {
                    callbacks: tooltipCallbacks
                    },
                    legend: {
                    ...edaPieLegend,
                    labels: {
                        ...(edaPieLegend?.labels || {}),
                        font: legendLabelsFont
                    }
                    }
                }
            };
            break;
            case 'bar':
                if (!['horizontalBar', 'pyramid', 'stackedbar100'].includes(chartSubType)) {
                    if (showLabels || showLabelsPercent ){ /** si mostro els datalabels els configuro */
                        dataLabelsObjt =  {
                            anchor: size.height>150?'end':'center',
                            align:  size.height>150?'top':'center',
                            display: 'auto',
                            color: function(context) {
                                return size.height>150?context.dataset.backgroundColor:'#ffffff';
                            },
                            font: {
                                weight: 'bold',
                                size: edaFontSize,
                            },
                            padding: 2,

                            formatter: (value,ctx) => {

                                const datapoints = ctx.dataset.data.map( x => x===''?0:x).map( x => x===undefined?0:x);
                                const total = datapoints.reduce((total, datapoint) => total +  datapoint , 0);

                                const percentage =  isNaN(value)?0:value  / total * 100
                                let res = '';
                                if( showLabels && showLabelsPercent){
                                    res = parseFloat(value).toLocaleString('de-DE', { maximumFractionDigits: 6 })  ;
                                    if(res == 'NaN'){ res = '';}
                                    res = res  + ' - ' + percentage.toLocaleString('de-DE', { maximumFractionDigits: 1 })    + ' %'  ;
                                }else if(showLabels && !showLabelsPercent){
                                    res = parseFloat(value).toLocaleString('de-DE', { maximumFractionDigits: 6 })  ;
                                    if(res == 'NaN'){ res = '';}
                                }else if(!showLabels && showLabelsPercent){
                                    res = percentage.toLocaleString('de-DE', { maximumFractionDigits: 1 })    + ' %'   ;
                                }
                                return   res;
                            }

                        }
                    } else {
                        dataLabelsObjt = { display: false };
                    }

                    options.chartOptions = {
                        animation: {
                            duration: 3000
                        },
                        color: colorStyle,
                        font: {
                            family: fontStyle,
                        },
                        responsive: true,
                        maintainAspectRatio: false,
                        devicePixelRatio: 2,
                        onHover: (event,chartElement ) => {
                            //Canviem el cursor de normal a tipus link
                            chartElement.length == 1 ? 
                            event.native.target.style.cursor = "pointer" :
                            event.native.target.style.cursor = "default";
                        },
                        tooltips: {
                            callbacks: {
                                title: (tooltipItem, data) => {
                                    if (data && tooltipItem)
                                        return ` ${labelColum[0].name} : ${data.labels[tooltipItem[0].index]}`;
                                },
                                label: (tooltipItem, data) => {
                                    if (data && tooltipItem) {
                                        const realData = data.datasets[tooltipItem.datasetIndex].data;
                                        const total = realData.reduce((a, b) => {
                                            if(isNaN(a)){a=0;}
                                            if(isNaN(b)){b=0;}
                                            return a + b;
                                        }, 0);
                                        const elem = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                                        const percentage = elem / total * 100;
                                        return ` ${data.labels[tooltipItem.index]}, ${numericColumn} : ${parseFloat(elem).toLocaleString('de-DE', { maximumFractionDigits: 6 })} (${percentage.toFixed(2)}%)`;
                                    }

                                },

                                afterLabel: (t, d) => {
                                },
                                footer: () => { return linked },
                            }
                        },

                        scales: {
                            x: {
                                stacked: stacked || false,
                                grid: { display: false },
                                ticks: {
                                maxRotation: ticksOptions.maxRotation || 30,
                                minRotation: ticksOptions.minRotation || 0,
                                labelOffset: ticksOptions.labelOffset || 0,
                                padding: ticksOptions.padding || 0,
                                maxTicksLimit: maxTicksLimit,
                                font: {
                                    size: edaFontSize,
                                    family: fontStyle,
                                    style: edafontStyle
                                },
                                    color: colorStyle,

                                callback: function(val, index) {
                                    const label = this.getLabelForValue(val);
                                    return label?.length > 20 ? label.substr(0, 17) + '...' : label;
                                },
                                autoSkip: true
                                }
                            },

                            y: {
                                display: maxTicksLimitY !== 0,
                                stacked: stacked || false,
                                grid: {
                                    display: showGridLines,
                                    drawBorder: false,
                                    color: colorStyle
                                },
                                beginAtZero: true,
                                grace: (showLabels || showLabelsPercent) ? '3%' : '3%',
                                ticks: {
                                autoSkip: true,
                                maxTicksLimit: maxTicksLimitY,
                                beginAtZero: true,
                                callback: (value) => {
                                    if (value)
                                    return isNaN(value) ? value : this.format10thPowers(parseFloat(value));
                                },

                                font: {
                                    size: edaFontSize,
                                    family: fontStyle,
                                },
                                color: colorStyle,
                                }
                            }
                            },


                        plugins: {
                            datalabels: dataLabelsObjt,
                            legend: edaBarLineLegend
                        },

                    };



                } else if (chartSubType=='stackedbar100') {
                    if(showLabels || showLabelsPercent ){
                        dataLabelsObjt =  {
                            anchor: size.height>150?'end':'center',
                            align:  size.height>150?'top':'center',
                            display: 'auto',
                            color: function(context) {
                                return size.height>150?context.dataset.backgroundColor:'#ffffff';
                                },
                            font: {
                                family: fontStyle,
                                weight: 'bold',
                                size:  edaFontSize  ,
                            },
                            padding: 2,

                            formatter: (values,ctx) => {

                                const dataIndex = ctx.dataIndex;
                                const value = ctx.dataset.value[dataIndex];
                                const percentage = ctx.dataset.data[dataIndex];

                                let res = '';
                                if( showLabels && showLabelsPercent){
                                    res = parseFloat(value).toLocaleString('de-DE', { maximumFractionDigits: 6 })  ;
                                    if(res == 'NaN'){ res = '';}
                                    res = res  + ' - ' + percentage.toLocaleString('de-DE', { maximumFractionDigits: 1 })    + ' %'  ;
                                }else if(showLabels && !showLabelsPercent){
                                    res = parseFloat(value).toLocaleString('de-DE', { maximumFractionDigits: 6 })  ;
                                    if(res == 'NaN'){ res = '';}
                                }else if(!showLabels && showLabelsPercent){
                                    res = percentage.toLocaleString('de-DE', { maximumFractionDigits: 1 })    + ' %'   ;
                                }
                                return   res;
                            }

                        }
                    }else{
                            dataLabelsObjt =   { display: false }
                    }

                    options.chartOptions = {
                        animation: {
                            duration: 3000
                        },
                        responsive: true,
                        maintainAspectRatio: false,
                        devicePixelRatio: 2,
                        layout: {
                            padding: {
                                top: (showLabels || showLabelsPercent) ? 60 : 0
                            }
                        },
                        tooltips: {
                            enabled: true,
                            callbacks: {
                                title: (tooltipItem, data) => {
                                    if (data && tooltipItem)
                                        return ` ${labelColum[0].name} : ${data.labels[tooltipItem[0].index]}`;
                                },
                                label: (tooltipItem, data) => {
                                    if (data && tooltipItem) {
                                        const realData = data.datasets[tooltipItem.datasetIndex].data;
                                        const total = realData.reduce((a, b) => {
                                            if(isNaN(a)){a=0;}
                                            if(isNaN(b)){b=0;}
                                            return a + b;
                                        }, 0);
                                        const elem = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                                        const percentage = elem / total * 100;
                                        return ` ${data.labels[tooltipItem.index]}, ${numericColumn} : ${parseFloat(elem).toLocaleString('de-DE', { maximumFractionDigits: 6 })} (${percentage.toFixed(2)}%)`;
                                    }

                                },

                                afterLabel: (t, d) => {
                                },
                                footer: () => { return linked },
                            }
                        },
                        scales: {
                            x: {
                                stacked: stacked || false,
                                grid: { display: false },

                                ticks: {
                                    callback: function(val, index) {
                                        if (this.getLabelForValue(val))
                                            return  this.getLabelForValue(val).length > 20 ? (this.getLabelForValue(val).substr(0, 17) + '...') : this.getLabelForValue(val);
                                    },
                                    maxRotation: ticksOptions.maxRotation || 30,
                                    minRotation: ticksOptions.minRotation || 0,
                                    labelOffset:  ticksOptions.labelOffset || 0,
                                    padding: ticksOptions.padding ||0,
                                    color: colorStyle,
                                    font: {
                                        family: fontStyle,
                                        size: edaFontSize,
                                        style: edafontStyle
                                    },
                                    maxTicksLimit: maxTicksLimit,
                                    autoSkip: true,
                                }
                            },

                            y: {
                                stacked: stacked || false,
                                grid: {
                                    display: showGridLines,
                                    drawBorder: false,
                                    color: colorStyle
                                },
                                grace: (showLabels || showLabelsPercent )?'1%': '0%',
                                min: 0,
                                max: 100,
                                ticks: {
                                    autoSkip: true,
                                    color: colorStyle,
                                    font: {
                                        family: fontStyle,
                                        size: edaFontSize,
                                        style: edafontStyle
                                    },
                                    maxTicksLimit: maxTicksLimitY,
                                    beginAtZero: true,
                                    callback: (value) => {
                                        if (value)
                                            return isNaN(value) ? value : this.format10thPowers(parseFloat(value)) //.toLocaleString('de-DE', { maximumFractionDigits: 6 });
                                    },
                                }
                            }

                        },
                        plugins: {
                            datalabels: dataLabelsObjt,
                            legend: edaBarLineLegend,
                            tooltip: {
                                mode: 'nearest',
                                intersect: true,
                                callbacks : {
                                    label: function(context) {
                                        let mode = context.dataset.mode;
                                        
                                        if (mode == 'textTwoNumericOne') {
                                            let dataIndex = context.dataIndex;
                                            let label = context.label;
                                            let serie = context.dataset.label;
                                            let value = context.dataset.value[dataIndex];
                                            let percentage = context.dataset.data[dataIndex];

                                            return `${serie} : ${parseFloat(value).toLocaleString('de-DE', { maximumFractionDigits: 6 })} - ${percentage.toFixed(2)}% `;

                                        } else if(mode == 'textOneNumericN') {
                                            let dataIndex = context.dataIndex;
                                            let label = context.label;
                                            let serie = context.dataset.label;
                                            let value = context.dataset.value[dataIndex];
                                            let percentage =context.dataset.data[dataIndex];

                                            return `${serie} : ${parseFloat(value).toLocaleString('de-DE', { maximumFractionDigits: 6 })} - ${percentage.toFixed(2)}% `;
                                        }
                                    }
                                }
                            }
                        },
                    };
                } else {
                    // horizontalBar Since chart.js 3 there is no more horizontal bar. Its just  barchart with horizonal axis
                    // buscar en chart.js las opciones
                    if (showLabels || showLabelsPercent ){
                        /** si haig de mostrar les etiquetes ho configuro */
                        dataLabelsObjt =  {
                            anchor: function(context) {
                                return context.dataset.data.some(el => el < 0) ? 'center' : 'end';
                            },
                            align: 'start',
                            display: function(context) {
                                const chartWidth = context.chart.width;
                                const realData = context.dataset.data;
                                const total = realData.reduce((a, b) => {
                                    if( a> b){
                                        return a;
                                    }else{
                                        return b;
                                    }
                                }, 0);
                                const elem = realData[context.dataIndex];

                                // Ensure is a postive number
                                const percentage = Math.abs(elem / total * 100);

                                if(chartWidth < 200){
                                    return  percentage > 30 ; /** Mostro la etiqueta si es mes que el 30 % del total  */
                                }else{
                                    return  percentage > 10 ; /** Mostro la etiqueta si es mes que el 30 % del total  */
                                }
                          },
                            color: 'white',
                            font: {
                                weight: 'bold',
                                size:  edaFontSize
                            },
                            formatter: (value,ctx) => {
                                const datapoints = ctx.dataset.data.map( x => x===''?0:x).map( x => x===undefined?0:x);
                                const total = datapoints.reduce((total, datapoint) => total + datapoint, 0)
                                const percentage = value / total * 100
                                let res = '';
                                if( showLabels && showLabelsPercent){
                                    res = parseFloat(value).toLocaleString('de-DE', { maximumFractionDigits: 6 })  ;
                                    if(res == 'NaN'){ res = '';}
                                    res = res  + ' - ' + percentage.toLocaleString('de-DE', { maximumFractionDigits: 1 })    + ' %'  ;
                                }else if(showLabels && !showLabelsPercent){
                                    res = parseFloat(value).toLocaleString('de-DE', { maximumFractionDigits: 6 })  ;
                                }else if(!showLabels && showLabelsPercent){
                                    res = percentage.toLocaleString('de-DE', { maximumFractionDigits: 1 })    + ' %'   ;
                                }
                                return   res;
                            },


                        }
                    } else {
                        dataLabelsObjt =   { display: false }
                    }
                    options.chartOptions  = {
                        animation: {
                            duration: 3000
                        },
                        indexAxis: 'y',
                        responsive: true,
                        maintainAspectRatio: false,
                        devicePixelRatio: 2,
                        legend: edaBarLineLegend,
                        onHover: (event,chartElement ) => {
                            //Canviem el cursor de normal a tipus link
                            chartElement.length == 1 ? 
                            event.native.target.style.cursor = "pointer" :
                            event.native.target.style.cursor = "default";
                        },
                        tooltips: {
                            mode: 'nearest',
                            callbacks: {
                                title: (tooltipItem, data) => {
                                    if (data && tooltipItem)
                                        return ` ${labelColum[0].name} : ${data.labels[tooltipItem[0].index]}`;
                                },

                                label: (tooltipItem, data) => {
                                    if (data && tooltipItem) {
                                        const realData = data.datasets[0].data;
                                        const total = realData.reduce((a, b) => {
                                            return a + b;
                                        }, 0);
                                        const elem = data.datasets[0].data[tooltipItem.index];
                                        const percentage = elem / total * 100;
                                        return ` ${data.labels[tooltipItem.index]}, ${numericColumn} : ${parseFloat(elem).toLocaleString('de-DE', { maximumFractionDigits: 6 })} (${percentage.toFixed(2)}%)`;
                                    }

                                },

                                footer: () => { return linked },
                            }

                        },
                        scales: {
                            x: {
                                grid: {
                                    display: showGridLines,
                                    drawBorder: false,
                                    color: colorStyle,
                                    callback: function(val, index) {
                                        if (this.getLabelForValue(val))
                                        return  this.getLabelForValue(val).length > 20 ? (this.getLabelForValue(val).substr(0, 12) + '...') : this.getLabelForValue(val);
                                    }
                                },
                                ticks: {
                                    color: colorStyle,
                                      font: {
                                          family: fontStyle,
                                          size: edaFontSize,
                                          style: edafontStyle
                                      },
                                    callback: (value) => {

                                        if (value)
                                            return isNaN(value) ? value : this.format10thPowers(parseFloat(value))// parseFloat(value).toLocaleString('de-DE', { maximumFractionDigits: 6 });
                                    },
                                    autoSkip: true,
                                    maxTicksLimit: maxTicksLimitHorizontal,
                                    beginAtZero: true
                                }
                            },
                            y: {
                                grid: { display: false },
                                beginAtZero: true,
                                ticks: {
                                    color: colorStyle,
                                      font: {
                                          family: fontStyle,
                                          size: edaFontSize,
                                          style: edafontStyle
                                      },
                                    beginAtZero: true,
                                    autoSkip: true
                                }
                            }
                        },

                        plugins: {
                            datalabels: dataLabelsObjt,
                            legend: edaBarLineLegend
                        },

                    };

                    if (chartSubType=='pyramid') {
                        //modificamos los valores del tooltip para que sea positivo.
                        (<any>options.chartOptions).plugins.tooltip = {
                            callbacks :{
                                label :  (context) =>{
                                    let label = context.dataset.label || '';
                                    if (label) { label += ': ';  }
                                    if (context.parsed.x !== null) {
                                        label += Math.abs( parseFloat( context.parsed.x )).toLocaleString('de-DE', { maximumFractionDigits: 6 }) ;
                                    }
                                    return label;
                                } 
                            },
                        };

                        //modificamos los valores del eje x para que sean positivos a la vista
                        (<any>options.chartOptions).scales.y.stacked = true;
                        (<any>options.chartOptions).scales.x.ticks.callback = (value, index, ticks) => {

                            if  (value < 0)  {
                                value = value * -1;
                            }

                            return value;
                        }
                    }
                }
                break;               
            case 'radar':
                if(showLabels || showLabelsPercent){
                    dataLabelsObjt =  {
                        anchor: 'end',
                        align: 'top',
                        display: function(context) {
                            const chartWidth = context.chart.width;
                            const realData = context.dataset.data;

                            if (( (chartWidth/10)  / realData.length  ) < 0.6 ){
                                return context.dataIndex%5==0  // devuelvo uno de cada 5
                            }else if (( (chartWidth/10)  / realData.length  ) < 1.5 ){
                                return context.dataIndex%2==0 // devuelvo uno de cada 2
                            }else{
                                return true; // devuelvo todas
                            }
                      },
                        color: colorStyle,
                        font: {
                          weight: 'bold',
                            size: edaFontSize - 2,
                        },
                        formatter: (value,ctx) => {
                            const datapoints = ctx.dataset.data.map( x => x===''?0:x).map( x => x===undefined?0:x);
                            const total = datapoints.reduce((total, datapoint) => total + datapoint, 0)
                            const percentage = value / total * 100
                            let res = '';
                            if( showLabels && showLabelsPercent){
                                res = parseFloat(value).toLocaleString('de-DE', { maximumFractionDigits: 6 })  ;
                                if(res == 'NaN'){ res = '';}
                                res = res  + ' - ' + percentage.toLocaleString('de-DE', { maximumFractionDigits: 1 })    + ' %'  ;
                            }else if(showLabels && !showLabelsPercent){
                                res = parseFloat(value).toLocaleString('de-DE', { maximumFractionDigits: 6 })  ;
                            }else if(!showLabels && showLabelsPercent){
                                res = percentage.toLocaleString('de-DE', { maximumFractionDigits: 1 })    + ' %'   ;
                            }
                            return   res;
                        }
                       }
                } else {
                    dataLabelsObjt = { display: false };
                }

                options.chartOptions = {
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: {
                        duration: 1500,
                    },
                    color: colorStyle,
                    font: {
                        family: fontStyle,
                    },
                    elements: {
                        line: {
                            borderColor: '#000000',
                            borderWidth: 2,
                        },
                        point: {
                            borderColor: '#000000',
                        }
                    },
                    scales: {
                        r: {
                            pointLabels: {
                                color: 'transparent',
                                font: {
                                    family: fontStyle,
                                }
                            },
                            ticks: {
                                color: colorStyle,
                                backdropColor: panelStyle,
                            },
                            angleLines: {
                                color: colorStyle
                            },
                            grid: {
                                color: colorStyle
                            }
                        }
                    },
                    plugins: {
                        datalabels: dataLabelsObjt,
                        legend: edaBarLineLegend
                    },
                }
                break;      
            case 'line':
                if(showLabels || showLabelsPercent){
                    dataLabelsObjt = {
                        
                        anchor: 'end',
                        align: 'top',
                        display: function(context) {
                            const chartWidth = context.chart.width;
                            const realData = context.dataset.data;

                            if (( (chartWidth/10)  / realData.length  ) < 0.6 ){
                                return context.dataIndex%5==0  // devuelvo uno de cada 5
                            }else if (( (chartWidth/10)  / realData.length  ) < 1.5 ){
                                return context.dataIndex%2==0 // devuelvo uno de cada 2
                            }else{
                                return true; // devuelvo todas
                            }
                        },


                        font: {
                          weight: 'bold',
                          size:  edaFontSize-2
                        },
                        formatter: (value,ctx) => {
                            const datapoints = ctx.dataset.data.map( x => x===''?0:x).map( x => x===undefined?0:x);
                            const total = datapoints.reduce((total, datapoint) => total + datapoint, 0)
                            const percentage = value / total * 100
                            let res = '';
                            if( showLabels && showLabelsPercent){
                                res = parseFloat(value).toLocaleString('de-DE', { maximumFractionDigits: 6 })  ;
                                if(res == 'NaN'){ res = '';}
                                res = res  + ' - ' + percentage.toLocaleString('de-DE', { maximumFractionDigits: 1 })    + ' %'  ;
                            }else if(showLabels && !showLabelsPercent){
                                res = parseFloat(value).toLocaleString('de-DE', { maximumFractionDigits: 6 })  ;
                            }else if(!showLabels && showLabelsPercent){
                                res = percentage.toLocaleString('de-DE', { maximumFractionDigits: 1 })    + ' %'   ;
                            }
                            return   res;
                        }
                      }
                }else{
                        dataLabelsObjt =   { display: false }
                }

                let pointRadius = 0;
                let pointHoverRadius = 3;
                let pointColor = '';
                if(showPointLines){
                    pointRadius = 5;
                    pointHoverRadius = 15;
                }
                options.chartOptions = {
                    animation: {
                        duration: 3000
                    },
                    showLines: true,
                    pointRadius: pointRadius,
                    pointHoverRadius: pointHoverRadius,
                    pointBackgroundColor : (ctx) => ctx.dataset.borderColor,
                    pointBorderColor :  (ctx) => ctx.dataset.borderColor, // revisar
                    spanGaps: true,
                    responsive: true,
                    maintainAspectRatio: false,
                    color: colorStyle,
                    font: {
                        family: fontStyle,
                    },
                    onHover: (event,chartElement ) => {
                        //Canviem el cursor de normal a tipus link
                        chartElement.length == 1 ? 
                        event.native.target.style.cursor = "pointer" :
                        event.native.target.style.cursor = "default";
                    },
                    tooltips: {
                        mode: 'nearest',
                        intersect: false,
                        callbacks: {
                            title: (tooltipItem, data) => {
                                if (data && tooltipItem) {
                                    return ` ${labelColum[0].name} : ${data.labels[tooltipItem[0].index]}`;
                                }
                            },

                            label: (tooltipItem, data) => {
                                if (data && tooltipItem) {
                                    const realData = data.datasets[tooltipItem.datasetIndex].data;
                                    let total = 0;
                                    for( let i = 0; i< realData.length; i++){
                                        if(isNaN( parseFloat(realData[i]))){
                                            total = total;
                                        }else{
                                            total = total + parseFloat(realData[i]);
                                        }
                                    }
                                    const elem = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                                    const percentage = elem / total * 100;
                                    return ` ${data.labels[tooltipItem.index]}, ${numericColumn} : ${parseFloat(elem).toLocaleString('de-DE', { maximumFractionDigits: 6 })} (${percentage.toFixed(2)}%)`;
                                }
                            },
                            footer: () => { return linked },
                        }
                    },
                    scales: {
                        x: {
                            grid: { display: false, drawOnChartArea: false },
                            ticks: {
                                maxRotation: ticksOptions.maxRotation || 30,
                                minRotation: ticksOptions.minRotation || 0,
                                labelOffset:  ticksOptions.labelOffset || 0,
                                padding: ticksOptions.padding ||0,
                                maxTicksLimit: maxTicksLimit,
                                callback: function(val, index) {
                                    if (this.getLabelForValue(val))
                                        return  this.getLabelForValue(val).length > 20 ? (this.getLabelForValue(val).substr(0, 17) + '...') : this.getLabelForValue(val);
                                },
                                autoSkip: true,
                                color: colorStyle,
                                font: {
                                    family: fontStyle,
                                    size: edaFontSize,
                                    style: edafontStyle
                                },
                                includeBounds:true,
                                beginAtZero: true
                            }
                        },
                        y: {
                            display: maxTicksLimitY !== 0,
                            grid: {
                                display: showGridLines,
                                drawBorder: false,
                                color: this.suavizaColor(  colorStyle, 0.1 ),
                                lineWidth:0.5,
                                zeroLineWidth: 1
                            },
                            id: 'y-axis-0', position: 'left',
                            beginAtZero: true,
                            ticks: {
                                callback: (value) => {
                                    if (value) {
                                        return isNaN(value) ? value : this.format10thPowers(parseFloat(value))// parseFloat(value).toLocaleString('de-DE', { maximumFractionDigits: 6 });
                                    } else {
                                        return 0;
                                    }
                                },

                                autoSkip: true,
                                maxTicksLimit: maxTicksLimitY,
                                color: colorStyle,
                                font: {
                                    family: fontStyle,
                                    size: edaFontSize,
                                    style: edafontStyle
                                },
                                beginAtZero: true,
                                max: minMax.max,
                                min: minMax.min

                            },
                            stacked: false
                        }
                    },
                    elements: {
                        point: { radius: 0, hitRadius: 4, hoverRadius: 3, hoverBorderWidth: 1, pointStyle: 'circle' },
                        line: {
                                borderWidth: 1 + Math.round(size.width/800),
                                fill:  chartSubType=='area'?true:false,
                                tension: 0.4 }
                    },
                    plugins: {
                        datalabels: dataLabelsObjt,
                        legend: edaBarLineLegend
                    },
                };
            break;
        }
        return options;
    }

    // APARTADO PARA LOS D3
    hex2rgbD3(hex, opacity = 100): string {
        hex = hex.replace('#', '');
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
    
        return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
      }
    
    rgb2hexD3(rgb): string {
        rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
        return (rgb && rgb.length === 4) ? '#' +
            ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2) +
            ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2) +
            ('0' + parseInt(rgb[3], 10).toString(16)).slice(-2) : '';  
    }

    /**
     * Reduce saturación de un color HEX
     * @param {string} hex - Color en formato #RRGGBB
     * @param {number} factor - Valor entre 0 y 1 (ej. 0.5 = mitad de saturación)
     * @returns {string} Nuevo color hex
     */
    private  suavizaColor(hex, factor) {
    hex = hex.replace(/^#/, "");
    let r = parseInt(hex.substring(0, 2), 16) / 255;
    let g = parseInt(hex.substring(2, 4), 16) / 255;
    let b = parseInt(hex.substring(4, 6), 16) / 255;

    let max = Math.max(r, g, b),
        min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;

    if (max === min) {
        h = s = 0; // gris
    } else {
        let d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }

    // Reducir saturación
    s *= factor;

    let q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    let p = 2 * l - q;

    function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }

    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);

        

        
    return "#" + 
        [r, g, b]
        .map(x => Math.round(x * 255).toString(16).padStart(2, "0"))
        .join("");
    }

    public generateChartColorsFromPalette(numberOfColors: number, baseColors: string[]): 
    Array<{ backgroundColor: string; borderColor: string }> {
        if (numberOfColors === 1) {
            const color = baseColors[0].toUpperCase();
            return [{ backgroundColor: color, borderColor: color }];
        }

        const result: Array<{ backgroundColor: string; borderColor: string }> = [];
        const numSegments = baseColors.length - 1;
        const baseRgbColors = baseColors.map(hex => this.hex2rgbNumericD3(hex));

        for (let i = 0; i < numberOfColors; i++) {
            const globalFactor = i / (numberOfColors - 1);
            let segmentIndex = Math.floor(globalFactor * numSegments);
            if (segmentIndex >= numSegments) {
                segmentIndex = numSegments - 1;
            }

            const [r1, g1, b1] = baseRgbColors[segmentIndex];
            const [r2, g2, b2] = baseRgbColors[segmentIndex + 1];

            const localFactor = globalFactor * numSegments - segmentIndex;
            const t = (i === numberOfColors - 1) ? 1 : localFactor;

            const r_interp = r1 + t * (r2 - r1);
            const g_interp = g1 + t * (g2 - g1);
            const b_interp = b1 + t * (b2 - b1);
            const interpolatedColorHex = this.rgbToHex(r_interp, g_interp, b_interp).toUpperCase();

            result.push({
                backgroundColor: interpolatedColorHex,
                borderColor: interpolatedColorHex
            });
        }

        return result;
    }

    // Metodo de prueba usado en treemap
    public resolveAssignedColors(categories: Array<string>, previous: AssignedColor[] = [], palette): AssignedColor[] {
        const resolved: AssignedColor[] = [...previous];

        categories.forEach((value, index) => {
            const exists = resolved.find(c => c.value === value);
            if (!exists) {
                resolved.push({
                    value,
                    color: palette[index % palette.length]
                });
            }
        });

        return resolved;
    }


    // METODOS PARA HACER LA GENERACIÓN DE COLORES DEL TREEMAP CON PALETA, REVISAR SI SE PUEDE UNIFICAR EN UN SERVICE 
    public generateRGBColorGradientScaleD3(
        numberOfColors: number,
        baseColors: string[]
      ): Array<{ color: string }> {
        // Charts de un único color
        if (numberOfColors === 1) {
            const color = baseColors[0].toUpperCase();
            return [{ color: color }];
        }
        const colorList: Array<{ color: string }> = [];
        const numSegments = baseColors.length - 1;
        const baseRgbColors = baseColors.map(hex => this.hex2rgbNumericD3(hex));
        //Generamos lista en rgb y pasamos a hex
        for (let i = 0; i < numberOfColors; i++) {
            const globalFactor = i / (numberOfColors - 1);
            let segmentIndex = Math.floor(globalFactor * numSegments);
            if (segmentIndex >= numSegments) {
                segmentIndex = numSegments - 1;
            }
          
            const [r1, g1, b1] = baseRgbColors[segmentIndex];
            const [r2, g2, b2] = baseRgbColors[segmentIndex + 1];
    
            const localFactor = (globalFactor * numSegments) - segmentIndex;
            const t = (i === numberOfColors - 1) ? 1 : localFactor;
    
            const r_interp = r1 + t * (r2 - r1);
            const g_interp = g1 + t * (g2 - g1);
            const b_interp = b1 + t * (b2 - b1);
            const interpolatedColorHex = this.rgbToHex(r_interp, g_interp, b_interp).toUpperCase();
            colorList.push({ color: interpolatedColorHex });
          }
        return colorList;
      }
      
      public hex2rgbNumericD3(hex: string): [number, number, number] {
        const cleanHex = hex.replace(/^#/, '');
        const fullHex = cleanHex.length === 3 ?
            cleanHex[0] + cleanHex[0] + cleanHex[1] + cleanHex[1] + cleanHex[2] + cleanHex[2] :
            cleanHex;
        if (fullHex.length !== 6) { return [0, 0, 0]; }
        const bigint = parseInt(fullHex, 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;
        return [r, g, b];
      }



      // Funcion para unificar todo tipo de inputs y que el output sea en HEX
    public rgbOrRgbaToHex(color: string): string {
        if(!color) return color;
        // Si ya es hex, devolvemos tal cual
        if (color.startsWith('#')) return color;

        // Extraemos valores de RGB o RGBA
        const match = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);

        const r = parseInt(match[1], 10);
        const g = parseInt(match[2], 10);
        const b = parseInt(match[3], 10);

        // Convertimos a hex
        return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase();
    }
    

}
